module.exports = __webpack_public_path__ + "static/media/mozza-2022-dt_en.a90dfbee.jpg";